const descriptions = require('../assets/descriptions.json');

const GetDescription = (mealId) => {
    return descriptions[mealId];
}

export default GetDescription;